import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // OktaAuthModule,
    // OktaRoutingModule,
    // OktaAuthModule.forRoot({ oktaAuth: oktaAuth }),
  ],
  // providers: [
  //   { provide: OKTA_CONFIG, useValue: oktaAuth }
  // ]
})
export class OktaModule {
}
